<template>
    <academic>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :fields="fields" :items="course_types" :action="{'text':'add course type','url':route('academic.coursetype.create')}"  :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Course Type')" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Course Type')">
                <template #status="data">
                    {{data.item.status?'Active':'Inactive'}}
                </template>
                <template #action="data">
                    <button-link v-if="hasRole('Edit Course Type')" :href="route('academic.coursetype.edit',data.item.id)" >Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'
    import {hasRole} from "../../../../Utils/checkPermission";

    export default {
        methods: {hasRole},
        components: {
            Academic,
            BreezeTable,
            ButtonLink
        },
        props:['course_types'],
        data(){
            return{
                fields:[{'key':'title','label':'Title'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}]
            }
        }
    }
</script>
